// extracted by mini-css-extract-plugin
export default {"ingredientsList":"BurgerIngredientsList_ingredientsList__pc+lv"};